import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/_services/dashboard/dashboard.service';

@Component({
  selector: 'app-settings-dialog',
  templateUrl: './settings-dialog.component.html',
  styleUrls: ['./settings-dialog.component.scss']
})
export class SettingsDialogComponent implements OnInit {

  constructor(
    public dashboardService: DashboardService
  ) { }

  ngOnInit() {
  }

}
